import { Skeleton } from '@/components/ui/skeleton'

export interface FieldSkeletonProps {
  /** How many label + input placeholders to render. */
  count?: number
}

/** Placeholder fields for a `field-grid`, while it is not yet known which fields to show. */
export function FieldSkeleton({ count = 1 }: FieldSkeletonProps) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div className="p-field" key={i}>
          <Skeleton className="h-3 w-20" />
          <Skeleton className="h-9 w-full" />
        </div>
      ))}
    </>
  )
}
